import { ENGLISH, type Translate } from "@khazzin/i18n";
import { humanise } from "@khazzin/ui/patterns/StatusChip";

/**
 * A server code in the reader's words (ADJ-M03-4): the catalog's label under
 * `prefix` when it has one, and the humanised code for one it does not know
 * yet — a carrier's own event type, a reason added after this build — so a
 * screen never shows a raw code, nor "…" for a missing key.
 */
export function named(t: Translate, prefix: string, code: string): string {
	const key = `${prefix}.${code}`;
	return key in ENGLISH ? t(key) : humanise(code);
}
